<template>
  <v-row align="center" justify="center" class="pa-4">
    <v-col>
      <h1 style="font-weight: 800; color: #FF0000">ข้อมูลสินค้า</h1>
    </v-col>
    <v-card class="pa-8" width="100%">
      <v-form ref="createForm" v-model="checkValidate" :lazy-validation="lazy">
        <v-row>
          <v-col cols="12" md="3" sm="3"
            ><span class="pt-4"><b>สถานะ</b></span>
          </v-col>
          <v-col cols="12" md="6" sm="6" class="">
            <v-switch
              v-model="activeFlag"
              label="ใช้งาน"
              class="mt-0"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row align="top" justify="center">
          <v-col cols="12" md="3" sm="3"
            ><span><b>หมวดหมู่ของกลุ่มสินค้า</b></span>
          </v-col>
          <v-col cols="12" md="9" sm="9">
            <span>{{ productDetail.category.category }}</span>
          </v-col>
          <!-- <v-col cols="12" md="3" sm="3"
            ><span><b>เลือกประเภทของกลุ่มสินค้า</b></span>
          </v-col>
          <v-col cols="12" md="9" sm="9">
            <span>{{ productDetail.category.category }}</span>
          </v-col> -->
          <v-col cols="12" md="3" sm="3"
            ><span><b>เลือกยี่ห้อของกลุ่มสินค้า</b></span>
          </v-col>
          <v-col cols="12" md="9" sm="9">
            <span>{{ productDetail.brand.brandName }}</span>
          </v-col>
          <!-- <v-col cols="12" md="3" sm="3"><span><b>รหัสสินค้า</b></span> </v-col>
          <v-col cols="12" md="9" sm="9">
            <span>{{ sku }}</span>
          </v-col> -->
          <v-col cols="12" md="3" sm="3"
            ><span><b>ชื่อกลุ่มสินค้า</b></span>
          </v-col>
          <v-col cols="12" md="9" sm="9">
            <span>{{ productDetail.groupName }}</span>
          </v-col>
          <v-col cols="12" md="3" sm="3"
            ><span><b>รายละเอียด</b></span>
          </v-col>
          <v-col cols="12" md="9" sm="9">
            <span>
              {{ productDetail.description }}
            </span>
          </v-col>
          <v-col cols="12" md="3" sm="3"
            ><span><b>สินค้าในกลุ่มสินค้า</b></span>
          </v-col>
          <v-col cols="12" md="12" sm="12" xs="12">
            <v-row
              v-for="(n, index) in productDetail.products"
              :key="index"
              align="center"
              class="py-0 my-0"
              style="border: 1px solid rgb(0 0 0); border-radius: 5px"
            >
              <v-col cols="12" md="6" sm="6"
                ><span
                  ><b>SKU:</b>
                  {{ n.sku }}
                </span>
              </v-col>
              <v-col cols="12" md="6" sm="6"
                ><span><b>ชื่อสินค้า:</b> {{ n.productName }}</span>
              </v-col>
              <v-col cols="12" md="12" sm="12"
                ><span><b>รายละเอียด:</b> {{ n.productName }}</span>
              </v-col>
              <v-col cols="12" md="6" sm="6"
                ><span><b>จำนวน (Stock):</b> {{ n.stockAmt }}</span>
              </v-col>
              <v-col cols="12" md="6" sm="6"
                ><span><b>หน่วยสินค้า:</b> {{ n.unit }}</span>
              </v-col>
              <v-col cols="12" md="12" sm="12"
                ><span
                  ><b>น้ำหนักสินค้า (สำหรับคำนวนค่าขนส่ง):</b>
                  {{ n.weight }}</span
                >
              </v-col>
              <v-col cols="12" md="6" sm="6"
                ><span><b>ราคาปกติ:</b> {{ n.price }} กก.</span>
              </v-col>
              <v-col cols="12" md="6" sm="6"
                ><span><b>ราคาส่วนลด:</b> {{ n.discountPrice }}</span>
              </v-col>
              <v-col cols="12" md="12" sm="12"
                ><span><b>ระยะเวลาเริ่มต้นของส่วนลด</b> </span>
              </v-col>
              <v-col cols="12" md="6" sm="6"
                ><span><b>วันที่เริ่มต้น:</b> {{ n.discountFrom }}</span>
              </v-col>
              <v-col cols="12" md="6" sm="6"
                ><span><b>วันที่สิ้นสุด:</b> {{ n.discountTo }}</span>
              </v-col>
              <!-- <v-col cols="12" md="8" sm="12"
                ><span>รายละเอียด</span>
                <v-text-field
                  v-model="productPriceList[index].listDescription"
                  placeholder="รายละเอียด"
                  solo
                  dense
                ></v-text-field>
              </v-col> -->
            </v-row>
          </v-col>
          <v-col cols="12" md="12" sm="6" xs="12">
            <v-card outlined>
              <v-row no-gutters align="center">
                <v-col cols="11" class="mt-5 ma-10" id="step-3">
                  <span>รูปสินค้าหลัก</span>

                  <v-img :src="showImage" width="200px"></v-img>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <v-col cols="12" class="mt-5">
            <v-card outlined>
              <v-row no-gutters align="center">
                <v-col cols="11" class="mt-5 ma-10" id="step-3">
                  <span>รูปภาพสินค้าเพิ่มเติม</span>
                </v-col>
                <v-col cols="12" class="mb-5"><v-divider></v-divider></v-col>
                <v-col
                  cols="12"
                  md="12"
                  class="pl-3 mb-5"
                  @click="onPickFile()"
                >
                  <v-row no-gutters align="center" justify="center">
                    <v-file-input
                      v-model="DataImage"
                      :items="DataImage"
                      accept="image/jpeg, image/jpg, image/png"
                      @change="UploadImage()"
                      id="file_input"
                      multiple
                      :clearable="false"
                      style="display: none"
                    ></v-file-input>
                    <v-img
                      max-width="50"
                      src="@/assets/upload.png"
                      class="mr-3"
                    ></v-img>
                    <span>เลือกรูปภาพ</span>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  v-if="product_image.length !== 0"
                  class="mb-5"
                >
                  <draggable
                    v-model="product_image"
                    :move="onMove"
                    @start="drag = true"
                    @end="drag = false"
                    class="pl-5 pr-5 row fill-height align-center sortable-list"
                  >
                    <v-col
                      v-for="(item, index) in product_image"
                      :key="index"
                      cols="3"
                      md="3"
                    >
                      <v-card dense light class="pa-1">
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-icon small light @click="RemoveImage(index, item)"
                            >mdi-close</v-icon
                          >
                        </v-card-actions>
                        <!-- <img width="100%"  :src="item.url" v-if="MethodProduct === 'Create'" />
                              <img width="100%" :src="`${PathImage}${item.url}`" v-else /> -->
                        <v-img
                          :src="item.productImgUrl"
                          aspect-ratio="1.8"
                          contain
                        ></v-img>
                        <v-card-text class="text-md-center">
                          <!-- <span class="subheading">{{item.name|truncate(20, '...') }}</span> -->
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </draggable>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-row class="ma-5" align="center" justify="end">
            <v-btn @click="cancel()" class="mr-4">กลับ</v-btn>
            <!-- <v-btn @click="submit()" color="primary">บันทึก</v-btn> -->
          </v-row>
        </v-row>
      </v-form>
    </v-card>
  </v-row>
</template>
<script>
import { Decode } from "@/services";
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  data() {
    return {
      id: "",
      category: "",
      itemsCategory: [],
      type: "",
      itemsType: [],
      brand: "",
      itemsBrand: [],
      company: "",
      itemsCompany: [],
      sku: "",
      productName: "",
      description: "",
      shortDesc: "",
      termDesc: "",
      stockAmt: "",
      unit: "",
      price: "",
      img: [],
      DataImage: [],
      product_image: [],
      pic1: "",
      picture_1: "",
      showImage: "",
      imageName1: "",
      activeFlag: true,
      cost: null,
      deliveryFee: null,
      setupFee: null,
      isHilight: false,
      showIndex: null,
      companyName: [],
      // listDescription: [],
      productPriceList: [],
      productOptionList: [],
      productDetail: null,

      // approveFlag: "",
      // itemsapproveFlag: [
      //   { text: "ยังไม่อนุมัติ", value: "0" },
      //   { text: "อนุมัติ", value: "1" },
      //   { text: "ตีกลับ", value: "2" },
      // ],
      rules: {
        required: [(v) => !!v || "กรุณากรอกข้อมูล"],
      },
      checkValidate: true,
      lazy: false,
    };
  },
  async created() {
    var productdata = JSON.parse(
      Decode.decode(localStorage.getItem("productdata"))
    );
    console.log("productdata", productdata);
    this.id = productdata.id;
    this.getOne();
    // this.itemsCategory = cateDropdown.data.data;
    // this.itemsType = typeDropdown.data.data;
    // console.log(this.itemsCategory, this.itemsType);
  },
  methods: {
    showPicture1(e) {
      // console.log('index',index);
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName1 = files[0].name;
        const element = files[0];
        const reader = new FileReader();
        reader.readAsDataURL(element);
        reader.onload = () => {
          this.pic1 = reader.result;
          this.showImage = URL.createObjectURL(element);
          // console.log(this.pic1);
        };
      }
    },
    changePic1() {
      document.getElementById("picTure1").click();
    },
    onPickFile() {
      document.getElementById("file_input").click();
    },
    UploadImage() {
      for (let i = 0; i < this.DataImage.length; i++) {
        const element = this.DataImage[i];
        const reader = new FileReader();
        reader.readAsDataURL(element);
        reader.onload = () => {
          var resultReader = reader.result;
          var url = URL.createObjectURL(element);
          this.product_image.push({
            image_data: resultReader,
            url: url,
            name: this.DataImage[i].name,
            id: "-1",
          });
        };
      }
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext;
      const draggedElement = draggedContext;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    RemoveImage(index, item) {
      console.log(index, item);
      if (item.id !== "-1") {
        this.Remove_img.push({
          id: item.id,
        });
      }
      this.product_image.splice(index, 1);
    },
    async getOne() {
      const response = await this.axios.get(
        `${process.env.VUE_APP_API}/products/findOneProductGroup?id=` + this.id
      );

      this.productDetail = response.data.data;

      console.log("Product", response);
      const Product = response.data.data;
      this.id = Product.id;
      this.activeFlag = Product.activeFlag;
      // this.category = Product.categoryId;
      // this.type = Product.typeId;
      // this.brand = Product.brandId;
      // this.company = Product.company;
      console.log(Product);
      if (Product.brandId) {
        this.brand = Product.brand;
      }
      // if (data.companyId) {
      //   this.company = data.company;
      // }
      // if (Product.categoryId) {
      this.category = Product.category.category;
      // }
      if (Product.typeId) {
        this.type = Product.type;
      }

      if (Product.productId) {
        this.product = Product.product;
      }
      // this.sku = Product.sku;
      // this.productName = Product.productName;
      // this.description = Product.description;
      // this.shortDesc = Product.shortDesc;
      // this.termDesc = Product.termDesc;
      // this.stockAmt = Product.stockAmt;
      // this.unit = Product.unit;
      // this.price = Product.price;
      // // this.img = Product.img;
      // this.cost = Product.cost;
      // this.deliveryFee = Product.deliveryFee;
      // this.setupFee = Product.setupFee;
      // this.isHilight = Product.isHilight;
      // this.showIndex = Product.showIndex;
      // this.companyName = Product.companyName;
      // this.productPriceList = Product.productPriceList;
      // this.productOptionList = Product.productOptionList;
      // this.productType = Product.productType;
      // this.productNumber = Product.productNumber;
      // this.productName = Product.productName;
      // this.description = Product.description;
      // this.lineId = Product.lineId;
      // this.rentPrice = Product.rentPrice;
      // this.province = Product.province;
      // this.user = Product.user;
      // this.product_image = Product.productImgs;
      this.showImage = Product.imgUrl;
      // this.picture_1 = Product.mainImg;
      // this.approveFlag = Product.approveFlag;
    },
    // UploadImage() {
    //   for (let i = 0; i < this.DataImage.length; i++) {
    //     const element = this.DataImage[i];
    //     const reader = new FileReader();
    //     reader.readAsDataURL(element);
    //     reader.onload = () => {
    //       var resultReader = reader.result;
    //       var url = URL.createObjectURL(element);
    //       this.product_image.push({
    //         image_data: resultReader,
    //         url: url,
    //         name: this.DataImage[i].name,
    //         id: "-1",
    //       });
    //     };
    //   }
    // },
    //  onPickFile() {
    //   document.getElementById("file_input").click();
    // },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext;
      const draggedElement = draggedContext;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    RemoveImage(index, item) {
      console.log(index, item);
      if (item.id !== "-1") {
        this.Remove_img.push({
          id: item.id,
        });
      }
      this.product_image.splice(index, 1);
    },
    cancel() {
      this.$router.push("ManageProduct");
    },
    async submit() {
      if (this.$refs.createForm.validate(true)) {
        const productData = {
          categoryId: this.category,
          typeId: this.type,
          brandId: this.brand,
          sku: this.sku,
          productName: this.productName,
          description: this.description,
          shortDesc: this.shortDesc,
          termDesc: this.termDesc,
          unit: this.unit,
          stockAmt: this.stockAmt,
          price: this.price,
          activeFlag: this.activeFlag,
          cost: this.cost,
          deliveryFee: this.deliveryFee,
          setupFee: this.setupFee,
          imgUrl: this.pic1,
          imgUrlDesc: this.product_image,
          productPriceList: this.productPriceList,
          productOptionList: this.productOptionList,
        };
        var user = JSON.parse(Decode.decode(localStorage.getItem("userHealthAdmin")));
        const auth = {
          headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjcsImVtYWlsIjoiaXR0aXd1dC53b25nM0BnbWFpbC5jb20iLCJwYXNzd29yZCI6IiQyYiQxMCRqU0UvY3RsSGhmTmJYemV5QXAvUHhPc3NOSS9HNG5NTHNsNlNBanFySzlVYzFMQmhDazh1UyIsImZpcnN0TmFtZSI6InNkZiIsImxhc3ROYW1lIjoic2RmIiwidGVsQ29kZSI6Iis2NiIsInRlbE51bWJlciI6IjIzNDU0NSIsImxpbmUiOiJkZnMiLCJnZW5kZXIiOiIiLCJhZ2UiOjEyLCJsaWNlbnNlTm8iOiIiLCJzY2hvb2wiOiIiLCJleHBlcmllbmNlIjoiZnNkZiIsImFsbGVyZ3kiOiJzZGYiLCJtaW5GZWUiOjEwLCJtYXhGZWUiOjIwLCJwcm92aW5jZSI6IuC4quC4oeC4uOC4l-C4o-C4m-C4o-C4suC4geC4suC4oyIsInVzZXJSZXF1ZXN0Ijoic2RmIiwiaWRDYXJkSW1nIjpudWxsLCJlZHVjYXRpb25JbWciOm51bGwsIndvcmtpbmdBcmVhIjoiamtqIiwibGF0IjpudWxsLCJsbmciOm51bGwsInNjaGVkdWxlIjoiWzIsM10iLCJyb2xlIjoiVVNFUiIsImlzUHJvIjpmYWxzZSwiaXNQdWJsaWMiOmZhbHNlLCJhY3RpdmVGbGFnIjp0cnVlLCJjcmVhdGVkQXQiOiIyMDIxLTExLTExVDA1OjQ3OjM4LjAwMFoiLCJ1cGRhdGVkQXQiOiIyMDIxLTExLTExVDExOjUxOjM2LjAwMFoiLCJqb2JJZCI6NCwiZWR1Y2F0aW9uSWQiOjEsImxpY2Vuc2VJZCI6MSwic2VydmljZVR5cGVJZCI6MSwiZmVlQ3VycmVuY3lJZCI6MSwiZmVlRnJlcXVlbmN5SWQiOjIsImlhdCI6MTYzNjkwODA0Mn0.4ctskWtU_WO5pDZMDa6M8vxLFCJZPaRCNxhNMiwl0-E` },
        };
        console.log("data", productData);
        const response = await this.axios.put(
          `${process.env.VUE_APP_API}/products/` + this.id,
          productData,
          auth
        );
        console.log("response product", response);
        if (response.data.response_status == "SUCCESS") {
          this.$swal.fire({
            icon: "success",
            text: `แก้ไขข้อมูลสินค้าสำเร็จ`,
            showConfirmButton: false,
            timer: 1500,
          });
          this.$router.push("ManageProduct");
        } else {
          this.$swal.fire({
            icon: "error",
            text: `แก้ไขข้อมูลสินค้าไม่สำเร็จ`,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    },
  },
};
</script>
